import React from 'react';
import { Box, Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        padding: theme.spacing(2),
    },
    tagGroup: {
        display: 'flex',
        alignItems: 'center',
        '& .MuiChip-root:first-child': {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRight: 'none',
        },
        '& .MuiChip-root:last-child': {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        }
    },
    labelChip: {
        backgroundColor: theme.palette.info.main,
        color: theme.palette.info.contrastText,
        fontWeight: 500,
        fontSize: '1.2rem',
        height: '2.4rem',
        '& .MuiChip-label': {
            padding: theme.spacing(0, 1.5),
        }
    },
    valueChip: {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700],
        fontWeight: 400,
        fontSize: '1.2rem',
        height: '2.4rem',
        border: `1px solid ${theme.palette.grey[300]}`,
        '& .MuiChip-label': {
            padding: theme.spacing(0, 1.5),
        }
    }
}));

const FilterSummary = ({ filter }) => {
    const classes = useStyles();

    const renderArrayFilterInfo = (name, arrayFilter) => {
        if (!arrayFilter || arrayFilter.length === 0)
            return null;

        return (
            <Box className={classes.tagGroup}>
                <Chip
                    label={name}
                    className={classes.labelChip}
                    size="small"
                />
                <Chip
                    label={arrayFilter.join(', ')}
                    className={classes.valueChip}
                    size="small"
                />
            </Box>
        )
    }

    const renderFilterInfo = (name, filterValue) => {
        if (!filterValue)
            return null;
        return (
            <Box className={classes.tagGroup}>
                <Chip
                    label={name}
                    className={classes.labelChip}
                    size="small"
                />
                <Chip
                    label={filterValue}
                    className={classes.valueChip}
                    size="small"
                />
            </Box>
        )
    }

    return (
        <Box className={classes.root}>
            {renderArrayFilterInfo('職種', filter.jobCategory)}
            {renderFilterInfo('雇用形態', filter.workType)}
            {renderFilterInfo('必要英語力', filter.englishLevel)}
            {renderArrayFilterInfo('タグ', filter.tags)}
        </Box>
    )
}

export default FilterSummary
